export class LoadModule {
    //Loading screen is shown when loadingScreenCounter > 0.
    private loadingScreenCounter: number = 0;

    public showLoadingScreen() {
        this.loadingScreenCounter++;

        let overlay = document.getElementById('overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'overlay';
            overlay.innerHTML = "<progress id='blobUploadProgress' value='0' max='100' style='display: none; width: 100%;'></progress><div id='waiting'>Loading... </div>";
            document.body.prepend(overlay);
        } else {
            overlay.style.transition = '';
            overlay.style.display = '';
            overlay.style.opacity = '1';
        }
    }

    public hideLoadingScreen(forceHide: boolean = false) {
        if (forceHide) {
            this.loadingScreenCounter = 0;
        } else if (this.loadingScreenCounter > 0) {
            this.loadingScreenCounter--;
        }

        if (this.loadingScreenCounter <= 0) {
            const overlay = document.getElementById('overlay');
            if (overlay) {
                overlay.style.transition = 'opacity 0.6s';
                overlay.style.opacity = '0';
                setTimeout(() => {
                    if (this.loadingScreenCounter <= 0 && overlay) {
                        overlay.style.display = 'none';
                        overlay.style.transition = '';
                    }
                }, 650);
            }
        }
    }
}

export let load = new LoadModule();

// Window registrations
(window as any).load = load;
(window as any).LoadModule = LoadModule;
